import * as Realm from "realm-web";
import config from "../configs/config.json";

const application = config.application;
const app: Realm.App = new Realm.App({ id: application });

// Anonymous credentials for public access
// Since access should be publicly available we can justify exposing these credentials
export const ANONYMOUS_EMAIL = "anonymous@rawbids.com";
export const ANONYMOUS_PASSWORD = "Rawbids_Anonymous_Access";

async function login() {
  const credentials = Realm.Credentials.anonymous();
  await app.logIn(credentials);
}

async function loginWithEmail(email: string, password: string) {
  const credentials = Realm.Credentials.emailPassword(email, password);
  await app.logIn(credentials);
}

async function loginAnonymous() {
  await loginWithEmail(ANONYMOUS_EMAIL, ANONYMOUS_PASSWORD);
}

function getUser() {
  return app.currentUser;
}


// eslint-disable-next-line import/no-anonymous-default-export
export default {
  login,
  loginWithEmail,
  loginAnonymous,
  getUser
};
